import { Component, OnInit, transition } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import * as _ from 'lodash';
import { TreeNode } from 'angular-tree-component';

import { FADE_IN_OUT_ANIMATION } from '@shared/animations';
import { Category, Sort, Language, ParseObject } from '@shared/data';
import { CategoryQuery } from '@shared/queries';
import { CrudService } from '@shared/services';
import { AlertService } from '@shared/modules/alert';
import { LoadingService } from '@shared/modules/loading';

import { CategoryListDataTableOptions } from './category-list.data-table-options';


@Component({
  moduleId: 'module.id',
  selector: 'category-list',
  styles: [require('./category-list.component.scss')],
  template: require('./category-list.component.html'),
  animations: [FADE_IN_OUT_ANIMATION]
})
export class CategoryListComponent implements OnInit {
  public categories: Category[];
  public searchText: string;
  public language: string;
  public error: Parse.Error;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loadingService: LoadingService,
    private crudService: CrudService,
    private alertService: AlertService) {

  }

  // ===============================================================================================
  // Override Methods
  // ===============================================================================================

  public ngOnInit(): void {
    this.fetchCategories();
  }

  // ===============================================================================================
  // Actions
  // ===============================================================================================

  public onSortChange(sort: Sort) {
    this.fetchCategories();
  }

  public onAdd(category: Category) {
    this.router.navigate(['add', category.id], {
      relativeTo: this.route
    });
  }

  public onEdit(category: Category) {
    this.router.navigate(['edit', category.id], {
      relativeTo: this.route
    });
  }

  public onDelete(category: Category): void {
    this.alertService.showDeleteWarning().then(
      result => {
        if (result) {
          this.loadingService.continue();

          this.crudService.destroy(category).then(
            (result) => {
              this.fetchCategories();
            },
            (error: Parse.Error) => {
              this.error = error;
              this.loadingService.complete();
            }
          );
        }
      }
    )
  }

  // ===============================================================================================
  // Private Methods
  // ===============================================================================================

  public fetchCategories() {
    let query = new CategoryQuery()
      .ascending(Category.SORT_ORDER_KEY)
      .include(Category.PARENT_KEY)
      .include(Category.IMAGE_KEY);

    this.loadingService.continue();

    query.find().then(
      (result: Category[]) => {
        this.categories = result.filter(c => !c.parent).map(c => {
          c['children'] = result.filter(o => o.parent && o.parent.id === c.id);
          return c;
        });

        _.take(this.categories, 2).forEach(o => {
          o['home'] = true;
        });

        this.loadingService.complete();
      },
      (error: Parse.Error) => {
        this.error = error;
        this.loadingService.complete();
      }
    );
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/+category/category-list/category-list.component.ts